var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2864.57 2734.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d4ecff;}.cls-3{opacity:0.7;}.cls-4{fill:url(#linear-gradient);}.cls-5{clip-path:url(#clip-path);}.cls-11,.cls-6{fill:#fff;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#bfc8d6;}.cls-10{fill:#97a6b7;}.cls-11{opacity:0.48;}.cls-11,.cls-55,.cls-70{isolation:isolate;}.cls-12{fill:#d8dee8;}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:#396caa;}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:#fcb048;}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#linear-gradient-21);}.cls-34{fill:url(#linear-gradient-22);}.cls-35{fill:url(#linear-gradient-23);}.cls-36{fill:url(#linear-gradient-24);}.cls-37{fill:url(#linear-gradient-25);}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#linear-gradient-29);}.cls-42{fill:url(#linear-gradient-30);}.cls-43{fill:url(#linear-gradient-31);}.cls-44{fill:url(#linear-gradient-32);}.cls-45{fill:url(#linear-gradient-33);}.cls-46{fill:url(#linear-gradient-34);}.cls-47{fill:url(#linear-gradient-35);}.cls-48{fill:url(#linear-gradient-36);}.cls-49{fill:url(#linear-gradient-37);}.cls-50{fill:url(#linear-gradient-38);}.cls-51{fill:url(#linear-gradient-39);}.cls-52{fill:url(#linear-gradient-40);}.cls-53{fill:url(#linear-gradient-41);}.cls-54{fill:url(#linear-gradient-42);}.cls-55,.cls-70{opacity:0.3;}.cls-55{fill:url(#linear-gradient-43);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-45);}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}.cls-62{fill:url(#linear-gradient-50);}.cls-63{opacity:0.15;}.cls-64{fill:url(#linear-gradient-51);}.cls-65{fill:url(#linear-gradient-52);}.cls-66{fill:url(#linear-gradient-53);}.cls-67{fill:url(#linear-gradient-54);}.cls-68{fill:url(#linear-gradient-55);}.cls-69{fill:url(#linear-gradient-56);}.cls-70{fill:url(#linear-gradient-57);}.cls-71{fill:url(#linear-gradient-58);}.cls-72{fill:url(#linear-gradient-59);}.cls-73{fill:url(#linear-gradient-60);}.cls-74{fill:url(#linear-gradient-61);}.cls-75{fill:url(#linear-gradient-62);}.cls-76{fill:url(#linear-gradient-63);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1745.13,
    y1: 2103.45,
    x2: 2910.35,
    y2: 2103.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-448.09 -486.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1745.13,2451.14c89.47-72.28,209.32-191.55,272.66-368.08,83.06-231.52-4-358.11,36.54-757.52C2080,1073,2100.43,897,2235,812.07c105.47-66.56,268.42-69.24,361.55,6.64,77.43,63.1,115.67,187.9,123.65,275.55,6.5,71.43-6.74,122,31.17,162.15,38.74,41.08,85.21,22.91,122,53.93,74.58,62.92,14.89,248.52,5.25,278.52-107.31,333.68-437.43,539.57-582.51,627.65C2176.17,2289.33,1991.9,2384.56,1745.13,2451.14Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3147.39,
    y1: 2331.73,
    x2: 2623.01,
    y2: 924.19,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-448.09 -486.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2099.77,2935.81c215.94-11.1,489.45-56,746.08-190.58,65.49-34.33,470.08-246.44,410-432.83-21.17-65.66-82.11-72.68-111.94-160-35.35-103.43,27.6-159.78,65.73-293.46,22.75-79.77,89.33-313.21-55.11-431.92-86.31-70.94-244.08-97.7-361-63.14-171.45,50.68-221.37,223.34-300.78,516.95-70.39,260.28-44.85,321.67-98.81,508.21C2353.92,2527.51,2274.52,2719.53,2099.77,2935.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1895.05,
    y1: 2424.64,
    x2: 960.32,
    y2: 491.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 768.85,
    y1: 2866.08,
    x2: 1563.32,
    y2: 1425.78,
    gradientTransform: "matrix(1, 0, 0, -1, -448.09, 3223.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1510.54,
    y1: 3187.11,
    x2: 2305.02,
    y2: 1746.81,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -1453.49, 1668.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1671.41,
    y1: 816.83,
    x2: 2199.23,
    y2: 816.83,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1937.75,
    y1: 876.29,
    x2: 1965.57,
    y2: 643.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feef06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1936.51,
    y1: 886.66,
    x2: 1945.05,
    y2: 815.13,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2822.64,
    y1: -448.48,
    x2: 2831.15,
    y2: -519.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.25, 3335.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f99c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#feba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fcad49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f99a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f57e53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1607.64,
    y1: 870.28,
    x2: 2135.45,
    y2: 870.28,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1873.98,
    y1: 929.73,
    x2: 1901.8,
    y2: 696.79,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1872.77,
    y1: 940.11,
    x2: 1881.31,
    y2: 868.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2886.41,
    y1: -501.93,
    x2: 2894.93,
    y2: -573.22,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1662.67,
    y1: 923.56,
    x2: 2190.48,
    y2: 923.56,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1929,
    y1: 983.02,
    x2: 1956.83,
    y2: 750.08,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1927.79,
    y1: 993.43,
    x2: 1936.34,
    y2: 921.86,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2831.38,
    y1: -555.21,
    x2: 2839.9,
    y2: -626.49,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1696.06,
    y1: 977.01,
    x2: 2223.87,
    y2: 977.01,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1962.39,
    y1: 1036.46,
    x2: 1990.22,
    y2: 803.52,
    gradientTransform: "matrix(1, 0, 0, -1, -448.09, 3223.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1961.17,
    y1: 1046.86,
    x2: 1969.72,
    y2: 975.3,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2798.01,
    y1: -608.65,
    x2: 2806.53,
    y2: -679.94,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1671.41,
    y1: 1034.68,
    x2: 2199.23,
    y2: 1034.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1937.75,
    y1: 1094.13,
    x2: 1965.57,
    y2: 861.18,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1936.51,
    y1: 1104.5,
    x2: 1945.04,
    y2: 1032.98,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2822.64,
    y1: -666.32,
    x2: 2831.16,
    y2: -737.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1607.64,
    y1: 1088.11,
    x2: 2135.45,
    y2: 1088.11,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1873.98,
    y1: 1147.57,
    x2: 1901.8,
    y2: 914.63,
    gradientTransform: "matrix(1, 0, 0, -1, -448.09, 3223.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1872.77,
    y1: 1157.94,
    x2: 1881.31,
    y2: 1086.43,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 2886.41,
    y1: -719.77,
    x2: 2894.93,
    y2: -791.05,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1662.67,
    y1: 1141.41,
    x2: 2190.48,
    y2: 1141.41,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1929,
    y1: 1200.86,
    x2: 1956.83,
    y2: 967.92,
    gradientTransform: "matrix(1, 0, 0, -1, -448.09, 3223.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1927.79,
    y1: 1211.26,
    x2: 1936.34,
    y2: 1139.69,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 2831.38,
    y1: -773.05,
    x2: 2839.89,
    y2: -844.34,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1634.05,
    y1: 1194.84,
    x2: 2161.86,
    y2: 1194.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1900.38,
    y1: 1254.3,
    x2: 1928.21,
    y2: 1021.36,
    gradientTransform: "matrix(1, 0, 0, -1, -448.09, 3223.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1899.17,
    y1: 1264.71,
    x2: 1907.72,
    y2: 1193.12,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 2860,
    y1: -826.5,
    x2: 2868.51,
    y2: -897.78,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1771.61,
    y1: 1377.7,
    x2: 1549.51,
    y2: 1306.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1951.27,
    y1: 1598.78,
    x2: 1753,
    y2: 1161.34,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1914.76,
    y1: 1136.88,
    x2: 1876.5,
    y2: 1345.89,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1833.69,
    y1: 1475.19,
    x2: 1991.35,
    y2: 1140.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1827.39,
    y1: 1547.2,
    x2: 1906.67,
    y2: 1250.07,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1787.3,
    y1: 1453.53,
    x2: 1944.65,
    y2: 1119.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 2637.5,
    y1: 2831.12,
    x2: 2334.12,
    y2: 1820.3,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8dee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1417.61,
    y1: 481.86,
    x2: 1531.55,
    y2: 481.86,
    gradientTransform: "matrix(1, 0.03, 0.03, -1, 1083.01, 3632.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1196.43,
    y1: 552.85,
    x2: 1237.3,
    y2: 552.85,
    gradientTransform: "matrix(1, 0, 0, -1, 1395.05, 3710)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1527.01,
    y1: 156.25,
    x2: 1648.14,
    y2: 156.25,
    gradientTransform: "matrix(0.96, 0.27, 0.27, -0.96, 617.55, 2892.81)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 832.03,
    y1: 566.37,
    x2: 882.51,
    y2: 566.37,
    gradientTransform: "matrix(1, 0, 0, -1, 1395.05, 3710)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 4266.58,
    y1: 745.43,
    x2: 3943.52,
    y2: 1473.68,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40447e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 3836.03,
    y1: 535.28,
    x2: 3512.98,
    y2: 1263.52,
    gradientTransform: "translate(6085.6 3981.49) rotate(-173.09)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 3684.44,
    y1: 895.11,
    x2: 3828.91,
    y2: 1581.36,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 4075.57,
    y1: 1491.46,
    x2: 4013.97,
    y2: 1665.99,
    gradientTransform: "translate(6006.12 3223.08) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 3806.47,
    y1: 1744.33,
    x2: 3829.05,
    y2: 1588.27,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1126.1,
    y1: 1719.79,
    x2: 1253.75,
    y2: 1719.79,
    gradientTransform: "matrix(1, 0, 0, -1, 1395.05, 3710)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 4254.02,
    y1: 1730.66,
    x2: 4133.92,
    y2: 1901.2,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 4023.65,
    y1: 1448.42,
    x2: 4286.48,
    y2: 1982.29,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 3895.22,
    y1: 1791.09,
    x2: 4472.61,
    y2: 1791.09,
    gradientTransform: "translate(6454.21 3710) rotate(180)",
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 577.53,
    y1: 1654.55,
    x2: 663.66,
    y2: 1654.55,
    gradientTransform: "matrix(1, 0, 0, -1, 1395.05, 3710)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1229.56,
    y1: 2350.69,
    x2: 1208.75,
    y2: 1997.01,
    gradientTransform: "matrix(1, 0, 0, -1, 1395.05, 3710)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 2914.93,
    y1: 930.24,
    x2: 2833.44,
    y2: 1137.21,
    gradientTransform: "matrix(0.94, 0.33, 0.33, -0.94, -445.49, 1446.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 2707.78,
    y1: 881.62,
    x2: 2812.18,
    y2: 881.62,
    gradientTransform: "matrix(0.94, 0.33, 0.33, -0.94, -312.35, 1326.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 2890.04,
    y1: 920.33,
    x2: 2808.46,
    y2: 1127.51,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 2717.82,
    y1: 863.69,
    x2: 2740.77,
    y2: 863.69,
    gradientTransform: "matrix(0.94, 0.33, 0.33, -0.94, -312.35, 1326.44)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2973,1065.59C2387.08,350.41,999.9,310.43,592,877.69,367.28,1190.24,461.19,1657.45,507.53,1888,592.8,2312.2,803.08,2585.31,849,2643.24c111.41,140.56,382,482,789.19,560.05,695.7,133.36,1563.81-545.63,1611.88-1311.68C3277.79,1450,3023.68,1127.43,2973,1065.59Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1745.13,2451.14c89.47-72.28,209.32-191.55,272.66-368.08,83.06-231.52-4-358.11,36.54-757.52C2080,1073,2100.43,897,2235,812.07c105.47-66.56,268.42-69.24,361.55,6.64,77.43,63.1,115.67,187.9,123.65,275.55,6.5,71.43-6.74,122,31.17,162.15,38.74,41.08,85.21,22.91,122,53.93,74.58,62.92,14.89,248.52,5.25,278.52-107.31,333.68-437.43,539.57-582.51,627.65C2176.17,2289.33,1991.9,2384.56,1745.13,2451.14Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1644.86,2506.75l-1.95-6.56c262.69-78.09,595.65-232.13,690.05-522.51,34.71-106.79,33.65-220.17,32.17-377.09-1.18-125.27-13.31-213.94-24-292.18-14-102.23-25-183-4.66-297.43,20.69-116.14,67.92-229.61,140.39-337.26l5.67,3.82c-72,106.85-118.83,219.46-139.35,334.64-20.19,113.39-9.2,193.67,4.71,295.3,10.73,78.44,22.9,167.35,24.08,293,1.43,151.64,2.55,271.41-32.51,379.26-44.83,137.91-148.09,258.42-306.92,358.2C1925.24,2405.39,1794.81,2462.17,1644.86,2506.75Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2367.3,1512.33l-3.42-1.8c-.79-.43-80.91-43.28-157.36-134.64-70.56-84.31-152.47-228.41-142-436.08l6.84.35c-10.39,205.32,70.5,347.77,140.19,431.12,66.72,79.81,136.19,122.18,152.12,131.31,84.74-220.26,216.17-352.54,311.76-424.83C2779.7,998.93,2865.17,972.37,2866,972.12l2,6.54c-.85.26-85.38,26.56-188.7,104.75-95.31,72.14-226.58,204.49-310.64,425.31Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2361,1850.87l-1.24-2.15c-.73-1.25-73.77-126.66-171.6-238-97.34-110.82-340.51-164.87-342.95-165.41l1.45-6.68c2.47.54,247.83,55.09,346.64,167.58,91.21,103.85,160.95,219.8,171.1,237,108.71-24.63,244.3-144,392.37-345.36,112.94-153.62,194.1-302.09,194.91-303.57l6,3.27c-.81,1.49-82.2,150.36-195.41,304.35C2610,1709,2475.8,1826.25,2363.45,1850.35Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2078.66,2307.8,2073,2304c74.48-109.7,74.83-230.63,1-359.41-55.19-96.32-133.4-160.94-134.18-161.58l4.34-5.3c.79.65,80,66.08,135.78,163.47C2131.68,2031.38,2173.43,2168.24,2078.66,2307.8Z",
    transform: "translate(-448.09 -486.92)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2099.77,2935.81c215.94-11.1,489.45-56,746.08-190.58,65.49-34.33,470.08-246.44,410-432.83-21.17-65.66-82.11-72.68-111.94-160-35.35-103.43,27.6-159.78,65.73-293.46,22.75-79.77,89.33-313.21-55.11-431.92-86.31-70.94-244.08-97.7-361-63.14-171.45,50.68-221.37,223.34-300.78,516.95-70.39,260.28-44.85,321.67-98.81,508.21C2353.92,2527.51,2274.52,2719.53,2099.77,2935.81Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1484.28,3086.46q-149.54,0-305.46-31.89l1.64-8c240,49.19,470.37,41.14,684.59-23.91,766.46-232.75,997.29-1131.81,1049.79-1401.82,29.79-153.27,12.63-320-51-495.71l7.66-2.78c64.16,177.07,81.44,345.31,51.36,500-43.17,222.07-136.3,549.12-334.79,846.09-191,285.68-433.4,474.75-720.63,562C1744.56,3067.79,1616.44,3086.46,1484.28,3086.46Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2793.38,2063.35l-2.47-2.7c-.64-.72-65.58-72.64-121.2-185-51.38-103.79-105.17-264.38-69.62-440l8,1.62c-35.07,173.26,18.07,331.94,68.83,434.54,49.06,99.15,105.38,166.48,117.62,180.58,440.93-324.58,416.54-665.07,398.51-761.87a45.36,45.36,0,0,1-.79-4.78l8.14-.44a37.39,37.39,0,0,0,.65,3.73c18.3,98.19,43.18,444.08-404.7,772.13Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2698.64,2470.34c-35.14,0-72.12-1.57-111-5l-2.17-.2-1-1.91c-1.4-2.55-140.08-260.12-134-621.67l6.17-364.66,8.14.14-6.17,364.65c-5.8,343.06,119.35,591.59,132,615.72,281.45,24.33,460.69-48.78,561.59-114.5,109.56-71.36,152.93-149.64,153.35-150.42l7.16,3.89c-.43.79-44.53,80.57-155.61,153.06C3068.67,2407.08,2921,2470.34,2698.64,2470.34Z",
    transform: "translate(-448.09 -486.92)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3041.68,2953.08,538.86,2931.75v63.12c0,17.13,10.91,31.7,25.7,34.3l707.72,124.3a99.09,99.09,0,0,0,25.39,1.17l1716.81-141.73c15.33-1.26,27.2-15.87,27.2-33.48Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2133.41,2851.93,564.74,2967.4c-28.07,2.07-50.9-19.89-50.9-49.05V1750.21c0-29.16,22.83-52.8,50.9-52.8H2133.41c23.13,0,41.83,21.37,41.83,47.73v1056C2175.24,2827.48,2156.54,2850.22,2133.41,2851.93Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2158.43,2851.93,589.75,2967.4c-28.07,2.07-50.89-19.89-50.89-49.05V1750.21c0-29.16,22.82-52.8,50.89-52.8H2158.43c23.12,0,41.82,21.37,41.82,47.73v1056C2200.25,2827.48,2181.55,2850.22,2158.43,2851.93Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2109.56,2777.48,648.5,2877.78c-22.84,1.57-41.41-16.45-41.41-40.25V1814.81c0-23.8,18.57-43.18,41.41-43.28l1461.06-6.3c19.07-.08,34.51,17.43,34.51,39.11v931.51C2144.07,2757.53,2128.63,2776.17,2109.56,2777.48Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1429.49,1729.36c0,10.86-8.07,19.68-18,19.71s-18.08-8.76-18.08-19.64,8.1-19.7,18.08-19.71S1429.49,1718.51,1429.49,1729.36Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M589.74,2967.4l1560.74-114.89,7.95-.59c10.61-.78,20.25-6,27.62-14-112.31-6.14-182.07-46-227.07-87.18-90.37-82.71-74.69-164.27-172.14-218.65-121.55-67.82-217.13,18.12-309.37-66.67-55.91-51.41-28.46-89.75-97.27-166.57-76.21-85.09-125.82-56.49-202.41-133.07-96.85-96.83-48.41-172.16-131.83-241.68-101.2-84.34-210.33-6.28-306.67-87.17-41.54-34.88-64.34-85.6-76.25-139.54H589.75c-28.07,0-50.89,23.64-50.89,52.8V2918.35C538.86,2947.51,561.68,2969.46,589.74,2967.4Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2221,2845.52,538.86,2967.07l733.42,128.81a99.09,99.09,0,0,0,25.39,1.17l1744-144-794-106.73A130,130,0,0,0,2221,2845.52Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "336.21 2481.19 1736.6 2378.49 2170.01 2436.29 781.68 2546.07 336.21 2481.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2362.15,2538c0,129.24-105.42,240.7-237.29,249.08L655.93,2880.33h0c155.33-9.86,279.35-131.35,279.35-271.49V996.7l1426.87,54.59Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1447.01 708.87 1462.31 708.87 1418.02 1812.79 1405.42 1812.79 1447.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1463.56 668.81 1462.87 668.81 1418.47 618.82 1419.04 618.82 1463.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1515.7 708.87 1535.46 708.87 1491.16 1812.79 1474.1 1812.79 1515.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "618.82 1537.07 668.81 1536.17 668.81 1491.78 618.82 1492.55 618.82 1537.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1584.38 708.87 1608.6 708.87 1564.3 1812.79 1542.78 1812.79 1584.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "618.82 1610.57 668.81 1609.48 668.81 1565.08 618.82 1566.06 618.82 1610.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1653.06 708.87 1681.74 708.87 1637.44 1812.79 1611.47 1812.79 1653.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1684.08 668.81 1682.78 668.81 1638.38 618.82 1639.56 618.82 1684.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1790.43 618.82 1831.09 618.82 1786.57 1812.79 1748.83 1812.79 1790.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1859.11 618.82 1904.6 618.82 1860.08 1812.79 1817.52 1812.79 1859.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1927.8 618.82 1978.1 618.82 1933.59 1812.79 1886.2 1812.79 1927.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1812.79 1996.48 618.82 2051.61 618.82 2007.09 1812.79 1954.88 1812.79 1996.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1011.68 1811.96 1016.36 1811.96 1062.48 618.82 1062.48 618.82 1011.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 933.64 1811.96 945.51 1811.96 991.63 618.82 984.44 618.82 933.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "618.82 808.52 1811.96 831.92 1811.96 920.78 618.82 906.4 618.82 808.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1152.42 1811.96 1149.6 1811.96 1171.58 618.82 1175.27 618.82 1152.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1196.02 1811.96 1191.54 1811.96 1213.51 618.82 1218.87 618.82 1196.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1239.63 1811.96 1233.48 1811.96 1255.45 618.82 1262.48 618.82 1239.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "618.82 1283.24 1811.96 1275.42 1811.96 1297.39 618.82 1306.09 618.82 1283.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1392.39 2198.91 1812.79 2174.4 1812.79 2197.89 1392.39 2222.4 1392.39 2198.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1188.8 2237.33 768.4 2262.69 768.4 2239.19 1188.8 2213.84 1188.8 2237.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 547.91,
    cy: 768.8,
    r: 354.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 547.91,
    cy: 768.8,
    r: 315.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1737.69,
    cy: 934.69,
    r: 354.77,
    transform: "translate(-600.06 1015.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1737.69,
    cy: 934.69,
    r: 315.14,
    transform: "translate(-600.06 1015.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1708.43,1130.48v-43.19c-38.39-1.92-75.83-12.48-96.46-23.51l17.27-69.1c24,11.51,58.54,24,96,24,25.43,0,44.64-5.76,44.64-21.6,0-14.39-14.89-22.55-54.72-32.15-56.13-13.43-100.29-38.87-100.29-91.18,0-46.54,33.59-82,93.59-92.13V738.9h57.1v39.35c37.9,1.44,62.38,8.64,81.1,16.32l-16.8,66.7C1816,856,1788.6,843,1746.86,843c-30.72,0-38.39,10.08-38.39,19.68,0,12,20.63,21.59,63.33,33.59,66.7,18.24,91.65,45.11,91.65,92.61,0,45.59-34.07,84-97.88,94.06v47.51Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1710.64,2852.84v50.88c0,16.44,102.7,29.77,229.39,29.77s229.4-13.33,229.4-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2169.43,2852.84c0,16.44-102.71,29.77-229.4,29.77s-229.39-13.33-229.39-29.77,102.7-29.77,229.39-29.77S2169.43,2836.4,2169.43,2852.84Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1940,2884.66c-112.2,0-229.53-10.71-229.53-31.38,0-1.14.41-3.13,1.54-3.13s.65,1.56.65,2.69c0,13.11,93.37,27.72,227.34,27.72s227.34-14.61,227.34-27.72c0-1.13.2-2.2,1.33-2.2s.86,1.52.86,2.65C2169.56,2874,2052.23,2884.66,1940,2884.66Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1918.35,2854.5c2.26-1.56,4.65-3.09,7.21-4.61a44.59,44.59,0,0,1,9.86-4.11,95,95,0,0,1,15.12-3,192.56,192.56,0,0,1,22.65-1.22q13.3-.07,25,.84a170.9,170.9,0,0,1,20.53,2.72,64.36,64.36,0,0,1,14.41,4.47q5.53,2.67,6.59,6.11l25.83.26a25.69,25.69,0,0,1,4.95.46c1.45.29,2.15.67,2.15,1.12v2.12l-33.21-.32q-1.74,3.91-8.9,7.15a89.89,89.89,0,0,1-18.21,5.62l-12.09-1.68a15.24,15.24,0,0,1-2.67-.63c-.7-.26-1-.53-1-.84s.93-.87,2.8-1.39,4-1.18,6.34-2a61.59,61.59,0,0,0,6.93-2.74,9.42,9.42,0,0,0,4.54-3.77l-78.37-.78a72.88,72.88,0,0,1-6.92,4.47,45.24,45.24,0,0,1-10.17,3.95,105.56,105.56,0,0,1-15.77,2.85,222.2,222.2,0,0,1-23.78,1.16c-7.19,0-14.18-.24-21-.81a144,144,0,0,1-18.25-2.61,56.85,56.85,0,0,1-13.09-4.28c-3.4-1.71-5.31-3.66-5.7-5.87l-21.26-.22a27.91,27.91,0,0,1-5-.44c-1.46-.29-2.21-.66-2.21-1.14v-2.12l29.07.27c1.29-2.24,3.92-4.19,8-5.85a91.41,91.41,0,0,1,14.75-4.44l9.74,1.34c3,.41,4.42.9,4.43,1.46,0,.3-.6.67-1.82,1.12s-2.69,1-4.37,1.6a40.43,40.43,0,0,0-4.84,2.18,10.19,10.19,0,0,0-3.54,2.84Zm-71.72,2.9a7.69,7.69,0,0,0,3.86,3.6,30.25,30.25,0,0,0,7.39,2.5,74.05,74.05,0,0,0,9.95,1.43q5.55.46,11.61.43a120.7,120.7,0,0,0,12.32-.61,72.15,72.15,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,37.94,37.94,0,0,0,5.3-2.83Zm170.62-1.9c-.58-1.42-2-2.65-4.22-3.72a38.36,38.36,0,0,0-8.5-2.68,96.9,96.9,0,0,0-12-1.62q-6.85-.53-15.14-.49a116.67,116.67,0,0,0-12.68.66,65.55,65.55,0,0,0-9.22,1.68,33.93,33.93,0,0,0-6.62,2.44,49.79,49.79,0,0,0-5.08,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1940.06,2826.3c-102.28,0-208.78,9-225.82,26.42a19.67,19.67,0,0,1,1.87,2c14.35-12.1,102.29-24.28,224-24.28,124.78,0,214.13,12.82,225,25.21a21,21,0,0,1,1.71-1.94C2152.66,2835.63,2044.16,2826.3,1940.06,2826.3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1646.87,2799.4v50.88c0,16.44,102.7,29.77,229.39,29.77s229.4-13.33,229.4-29.77V2799.4Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2105.66,2799.4c0,16.44-102.71,29.77-229.4,29.77s-229.39-13.33-229.39-29.77,102.7-29.77,229.39-29.77S2105.66,2783,2105.66,2799.4Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1876.26,2831.22c-112.2,0-229.53-10.72-229.53-31.39,0-1.13.41-3.13,1.54-3.13s.65,1.56.65,2.7c0,13.11,93.36,27.71,227.34,27.71s227.34-14.6,227.34-27.71c0-1.14.19-2.2,1.33-2.2s.86,1.51.86,2.65C2105.79,2820.52,1988.46,2831.22,1876.26,2831.22Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1854.58,2801.06c2.25-1.56,4.66-3.1,7.21-4.61a44.59,44.59,0,0,1,9.86-4.11,92.79,92.79,0,0,1,15.12-3,194.75,194.75,0,0,1,22.65-1.23q13.3-.06,25,.85a167,167,0,0,1,20.53,2.72,63.35,63.35,0,0,1,14.41,4.47q5.54,2.67,6.59,6.11l25.83.26a24.69,24.69,0,0,1,5,.46c1.45.29,2.14.66,2.15,1.11v2.13l-33.21-.32q-1.74,3.9-8.9,7.15a90.73,90.73,0,0,1-18.21,5.62l-12.09-1.69a13.64,13.64,0,0,1-2.67-.63c-.7-.25-1-.53-1-.83s.93-.88,2.8-1.4,4-1.17,6.34-2a63.55,63.55,0,0,0,6.93-2.74,9.42,9.42,0,0,0,4.54-3.77l-78.37-.78a76.33,76.33,0,0,1-6.93,4.46,44.66,44.66,0,0,1-10.16,4,105.56,105.56,0,0,1-15.77,2.85,224.85,224.85,0,0,1-23.78,1.17c-7.19,0-14.18-.24-21-.82a145.78,145.78,0,0,1-18.25-2.6,57.36,57.36,0,0,1-13.09-4.29q-5.1-2.55-5.7-5.87l-21.26-.22a27,27,0,0,1-5-.44c-1.47-.28-2.21-.66-2.21-1.13v-2.13l29.08.28c1.28-2.24,3.92-4.19,8-5.85a89.15,89.15,0,0,1,14.75-4.44l9.74,1.33c3,.42,4.42.9,4.43,1.46,0,.3-.6.68-1.82,1.12l-4.37,1.6a42.14,42.14,0,0,0-4.84,2.19,10.19,10.19,0,0,0-3.54,2.84Zm-71.72,2.9a7.69,7.69,0,0,0,3.86,3.6,30.65,30.65,0,0,0,7.39,2.49,73.44,73.44,0,0,0,10,1.44q5.55.45,11.61.43a107.59,107.59,0,0,0,12.32-.61,75.84,75.84,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,39,39,0,0,0,5.3-2.83Zm170.62-1.91c-.58-1.41-2-2.65-4.22-3.71a38.36,38.36,0,0,0-8.5-2.68,93.25,93.25,0,0,0-12-1.62q-6.85-.52-15.14-.49a111.84,111.84,0,0,0-12.68.66,64.12,64.12,0,0,0-9.22,1.67,33.33,33.33,0,0,0-6.62,2.45,48,48,0,0,0-5.08,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1876.29,2772.85c-102.28,0-208.78,9-225.82,26.42a19.67,19.67,0,0,1,1.87,2c14.35-12.1,102.29-24.28,224-24.28,124.78,0,214.13,12.81,225,25.21a21.73,21.73,0,0,1,1.71-2C2088.89,2782.18,1980.39,2772.85,1876.29,2772.85Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1701.89,2746.11V2797c0,16.44,102.7,29.77,229.4,29.77s229.39-13.33,229.39-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2160.68,2746.11c0,16.44-102.7,29.77-229.39,29.77s-229.4-13.33-229.4-29.77,102.7-29.77,229.4-29.77S2160.68,2729.67,2160.68,2746.11Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1931.29,2777.93c-112.21,0-229.53-10.71-229.53-31.39,0-1.13.4-3.13,1.54-3.13s.64,1.56.64,2.7c0,13.11,93.37,27.71,227.35,27.71s227.34-14.6,227.34-27.71c0-1.14.19-2.2,1.33-2.2s.86,1.52.86,2.65C2160.82,2767.23,2043.49,2777.93,1931.29,2777.93Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1909.61,2747.77c2.25-1.56,4.64-3.09,7.21-4.61a44.71,44.71,0,0,1,9.85-4.11,95,95,0,0,1,15.12-3,192.73,192.73,0,0,1,22.66-1.22q13.29-.07,25,.84a170.9,170.9,0,0,1,20.53,2.72,63.27,63.27,0,0,1,14.42,4.47q5.52,2.67,6.59,6.11l25.83.26a24.92,24.92,0,0,1,4.95.46c1.44.29,2.14.66,2.14,1.12v2.12l-33.2-.32c-1.17,2.61-4.13,5-8.91,7.15a90.44,90.44,0,0,1-18.2,5.62l-12.1-1.68a14.42,14.42,0,0,1-2.67-.64c-.7-.25-1-.53-1-.83s.94-.87,2.81-1.4,4-1.17,6.33-2a61.59,61.59,0,0,0,6.93-2.74,9.45,9.45,0,0,0,4.55-3.77l-78.38-.78a72.88,72.88,0,0,1-6.92,4.47A45.24,45.24,0,0,1,1913,2760a106.83,106.83,0,0,1-15.77,2.84,224.85,224.85,0,0,1-23.78,1.17q-10.77,0-21-.82a142,142,0,0,1-18.24-2.6,57.08,57.08,0,0,1-13.1-4.28c-3.39-1.71-5.3-3.66-5.7-5.87l-21.26-.22a27.91,27.91,0,0,1-5-.44c-1.47-.29-2.22-.66-2.22-1.14v-2.12l29.07.27c1.29-2.24,3.92-4.19,8-5.85a90.23,90.23,0,0,1,14.76-4.44l9.73,1.34c3,.41,4.43.9,4.43,1.46,0,.3-.6.67-1.82,1.12s-2.69,1-4.36,1.6a39.72,39.72,0,0,0-4.85,2.18,10.28,10.28,0,0,0-3.54,2.84Zm-71.73,2.9a7.69,7.69,0,0,0,3.86,3.6,30.25,30.25,0,0,0,7.39,2.5,74.28,74.28,0,0,0,9.95,1.43q5.57.45,11.61.43A120.52,120.52,0,0,0,1883,2758a70.44,70.44,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,37.94,37.94,0,0,0,5.3-2.83Zm170.63-1.9q-.88-2.13-4.23-3.72a38.11,38.11,0,0,0-8.49-2.68,93.25,93.25,0,0,0-12-1.62q-6.84-.52-15.14-.49a116.67,116.67,0,0,0-12.68.66,67,67,0,0,0-9.22,1.67,33.33,33.33,0,0,0-6.62,2.45,45.32,45.32,0,0,0-5.07,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1931.32,2719.56c-102.29,0-208.79,9-225.82,26.43a19.57,19.57,0,0,1,1.86,2c14.36-12.1,102.3-24.28,224-24.28,124.78,0,214.13,12.81,225,25.21a19.71,19.71,0,0,1,1.72-1.94C2143.92,2728.9,2035.42,2719.56,1931.32,2719.56Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1735.28,2692.67v50.88c0,16.44,102.71,29.77,229.4,29.77s229.39-13.33,229.39-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 1516.59,
    cy: 2205.75,
    rx: 229.39,
    ry: 29.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1964.68,2724.49c-112.21,0-229.53-10.72-229.53-31.39,0-1.13.4-3.13,1.54-3.13s.65,1.56.65,2.7c0,13.1,93.36,27.71,227.34,27.71S2192,2705.77,2192,2692.67c0-1.14.19-2.2,1.33-2.2s.86,1.51.86,2.65C2194.21,2713.79,2076.88,2724.49,1964.68,2724.49Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1943,2694.33c2.25-1.56,4.66-3.1,7.21-4.62a45.66,45.66,0,0,1,9.85-4.1,92.7,92.7,0,0,1,15.13-3,190.44,190.44,0,0,1,22.65-1.23q13.29-.06,25,.85a166.86,166.86,0,0,1,20.54,2.72,63.19,63.19,0,0,1,14.41,4.47q5.52,2.67,6.59,6.1l25.83.27a25.68,25.68,0,0,1,4.95.45c1.44.3,2.14.67,2.14,1.12v2.13l-33.2-.32q-1.76,3.9-8.9,7.15a90.06,90.06,0,0,1-18.21,5.61l-12.1-1.68a13.64,13.64,0,0,1-2.67-.63c-.69-.25-1-.53-1-.83s.93-.88,2.8-1.4,4-1.18,6.33-2a63.55,63.55,0,0,0,6.93-2.74,9.37,9.37,0,0,0,4.55-3.78l-78.38-.77a74.81,74.81,0,0,1-6.92,4.46,44.28,44.28,0,0,1-10.17,4,105.56,105.56,0,0,1-15.77,2.85,222.2,222.2,0,0,1-23.78,1.16q-10.77.06-21-.81a145.62,145.62,0,0,1-18.24-2.6,57.6,57.6,0,0,1-13.1-4.29c-3.39-1.7-5.3-3.66-5.69-5.87l-21.27-.22a27,27,0,0,1-5-.44c-1.47-.28-2.22-.66-2.22-1.13v-2.13l29.07.28c1.29-2.24,3.92-4.2,8-5.86a91.52,91.52,0,0,1,14.76-4.44l9.73,1.34c3,.42,4.43.9,4.43,1.46,0,.3-.6.68-1.82,1.12l-4.36,1.6a39.78,39.78,0,0,0-4.85,2.19,10.46,10.46,0,0,0-3.54,2.83Zm-71.73,2.89a7.71,7.71,0,0,0,3.86,3.61,30.65,30.65,0,0,0,7.39,2.49,76.7,76.7,0,0,0,10,1.44q5.55.45,11.6.42a120.69,120.69,0,0,0,12.32-.6,72.18,72.18,0,0,0,9.22-1.57,43.68,43.68,0,0,0,6.94-2.28,39.51,39.51,0,0,0,5.29-2.83Zm170.63-1.9q-.89-2.12-4.23-3.71a37.63,37.63,0,0,0-8.49-2.69,95,95,0,0,0-12-1.61q-6.84-.53-15.13-.49a112,112,0,0,0-12.69.66,64,64,0,0,0-9.21,1.67,33.1,33.1,0,0,0-6.62,2.45,45.45,45.45,0,0,0-5.08,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1964.71,2666.12c-102.29,0-208.79,9-225.82,26.42a19.57,19.57,0,0,1,1.86,2c14.36-12.09,102.3-24.27,224-24.27,124.78,0,214.13,12.81,224.95,25.21a20.39,20.39,0,0,1,1.72-2C2177.31,2675.45,2068.81,2666.12,1964.71,2666.12Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1710.64,2635v50.88c0,16.44,102.7,29.77,229.39,29.77s229.4-13.33,229.4-29.77V2635Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2169.43,2635c0,16.44-102.71,29.76-229.4,29.76s-229.39-13.32-229.39-29.76,102.7-29.77,229.39-29.77S2169.43,2618.56,2169.43,2635Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1940,2666.83c-112.2,0-229.53-10.72-229.53-31.39,0-1.14.41-3.13,1.54-3.13s.65,1.56.65,2.7c0,13.1,93.37,27.71,227.34,27.71s227.34-14.61,227.34-27.71c0-1.14.2-2.2,1.33-2.2s.86,1.51.86,2.65C2169.56,2656.13,2052.23,2666.83,1940,2666.83Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1918.35,2636.66c2.26-1.55,4.65-3.09,7.21-4.61a45.77,45.77,0,0,1,9.86-4.11,95,95,0,0,1,15.12-3,192.56,192.56,0,0,1,22.65-1.22q13.3-.06,25,.85a167,167,0,0,1,20.53,2.72,63.19,63.19,0,0,1,14.41,4.47q5.53,2.65,6.59,6.1l25.83.27a25.68,25.68,0,0,1,4.95.45c1.45.3,2.15.67,2.15,1.12v2.13l-33.21-.32q-1.74,3.9-8.9,7.15a90.06,90.06,0,0,1-18.21,5.61l-12.09-1.68a13.64,13.64,0,0,1-2.67-.63c-.7-.25-1-.53-1-.83s.93-.88,2.8-1.4,4-1.18,6.34-1.95a64.36,64.36,0,0,0,6.93-2.74,9.34,9.34,0,0,0,4.54-3.78l-78.37-.77a74.81,74.81,0,0,1-6.92,4.46,45.24,45.24,0,0,1-10.17,4,105.56,105.56,0,0,1-15.77,2.85,222.2,222.2,0,0,1-23.78,1.16c-7.19,0-14.18-.23-21-.81a145.78,145.78,0,0,1-18.25-2.6,57.36,57.36,0,0,1-13.09-4.29c-3.4-1.7-5.31-3.66-5.7-5.87l-21.26-.22a27.91,27.91,0,0,1-5-.44c-1.46-.28-2.21-.66-2.21-1.13v-2.13l29.07.28c1.29-2.24,3.92-4.2,8-5.86a91.41,91.41,0,0,1,14.75-4.44l9.74,1.34c3,.42,4.42.9,4.43,1.46,0,.3-.6.68-1.82,1.12l-4.37,1.6a39,39,0,0,0-4.84,2.19,10,10,0,0,0-3.54,2.83Zm-71.72,2.9a7.71,7.71,0,0,0,3.86,3.61,30.65,30.65,0,0,0,7.39,2.49,76,76,0,0,0,9.95,1.44q5.55.45,11.61.42a120.69,120.69,0,0,0,12.32-.6,72.18,72.18,0,0,0,9.22-1.57,42.3,42.3,0,0,0,6.93-2.29,37.88,37.88,0,0,0,5.3-2.82Zm170.62-1.9c-.58-1.41-2-2.65-4.22-3.72a38.36,38.36,0,0,0-8.5-2.68,95,95,0,0,0-12-1.61q-6.85-.53-15.14-.49a111.84,111.84,0,0,0-12.68.66,64.12,64.12,0,0,0-9.22,1.67,33.33,33.33,0,0,0-6.62,2.45,48,48,0,0,0-5.08,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1940.06,2608.46c-102.28,0-208.78,9-225.82,26.42a20.78,20.78,0,0,1,1.87,2c14.35-12.09,102.29-24.27,224-24.27,124.78,0,214.13,12.81,225,25.21a21.73,21.73,0,0,1,1.71-2C2152.66,2617.79,2044.16,2608.46,1940.06,2608.46Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1646.87,2581.56v50.88c0,16.44,102.7,29.77,229.39,29.77s229.4-13.33,229.4-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 1428.17,
    cy: 2094.64,
    rx: 229.4,
    ry: 29.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1876.26,2613.38c-112.2,0-229.53-10.71-229.53-31.38,0-1.14.41-3.13,1.54-3.13s.65,1.56.65,2.69c0,13.11,93.36,27.72,227.34,27.72s227.34-14.61,227.34-27.72c0-1.13.19-2.2,1.33-2.2s.86,1.52.86,2.65C2105.79,2602.68,1988.46,2613.38,1876.26,2613.38Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1854.58,2583.22c2.25-1.56,4.65-3.09,7.21-4.61a44.59,44.59,0,0,1,9.86-4.11,95,95,0,0,1,15.12-3,192.56,192.56,0,0,1,22.65-1.22q13.3-.08,25,.84a170.9,170.9,0,0,1,20.53,2.72,64.36,64.36,0,0,1,14.41,4.47q5.54,2.67,6.59,6.11l25.83.26a24.69,24.69,0,0,1,5,.46c1.45.29,2.14.67,2.15,1.12v2.12l-33.21-.32q-1.74,3.92-8.9,7.15a90.53,90.53,0,0,1-18.21,5.62l-12.09-1.68a15.24,15.24,0,0,1-2.67-.63c-.7-.26-1-.53-1-.84s.93-.87,2.8-1.39,4-1.18,6.34-2a61.59,61.59,0,0,0,6.93-2.74,9.42,9.42,0,0,0,4.54-3.77l-78.37-.78a74.33,74.33,0,0,1-6.93,4.47,45.16,45.16,0,0,1-10.16,4,105.56,105.56,0,0,1-15.77,2.85,222.2,222.2,0,0,1-23.78,1.16c-7.19,0-14.18-.24-21-.82a142.17,142.17,0,0,1-18.25-2.6,56.85,56.85,0,0,1-13.09-4.28c-3.4-1.71-5.3-3.66-5.7-5.87l-21.26-.22a27.91,27.91,0,0,1-5-.44c-1.47-.29-2.21-.66-2.21-1.14v-2.12l29.08.27c1.28-2.24,3.92-4.19,8-5.85a89.15,89.15,0,0,1,14.75-4.44l9.74,1.34c3,.41,4.42.9,4.43,1.46,0,.3-.6.67-1.82,1.12s-2.69,1-4.37,1.6a40.43,40.43,0,0,0-4.84,2.18,10.19,10.19,0,0,0-3.54,2.84Zm-71.72,2.9a7.69,7.69,0,0,0,3.86,3.6,30.25,30.25,0,0,0,7.39,2.5,75,75,0,0,0,10,1.43q5.55.46,11.61.43a120.7,120.7,0,0,0,12.32-.61,72.15,72.15,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,39,39,0,0,0,5.3-2.83Zm170.62-1.9c-.58-1.42-2-2.65-4.22-3.72a38.36,38.36,0,0,0-8.5-2.68,96.9,96.9,0,0,0-12-1.62q-6.85-.52-15.14-.49a116.67,116.67,0,0,0-12.68.66,65.55,65.55,0,0,0-9.22,1.68,33.93,33.93,0,0,0-6.62,2.44,49.79,49.79,0,0,0-5.08,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1876.29,2555c-102.28,0-208.78,9-225.82,26.43a19.67,19.67,0,0,1,1.87,2c14.35-12.1,102.29-24.28,224-24.28,124.78,0,214.13,12.82,225,25.21a21,21,0,0,1,1.71-1.94C2088.89,2564.35,1980.39,2555,1876.29,2555Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1701.89,2528.27v50.88c0,16.45,102.7,29.77,229.4,29.77s229.39-13.32,229.39-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 1483.2,
    cy: 2041.35,
    rx: 229.4,
    ry: 29.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1931.29,2560.1c-112.21,0-229.53-10.72-229.53-31.39,0-1.14.4-3.13,1.54-3.13s.64,1.56.64,2.69c0,13.11,93.37,27.72,227.35,27.72s227.34-14.61,227.34-27.72c0-1.13.19-2.2,1.33-2.2s.86,1.52.86,2.65C2160.82,2549.4,2043.49,2560.1,1931.29,2560.1Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1909.61,2529.93c2.25-1.56,4.64-3.09,7.21-4.61a45.69,45.69,0,0,1,9.85-4.11,95,95,0,0,1,15.12-3,192.73,192.73,0,0,1,22.66-1.22q13.29-.06,25,.85a170.88,170.88,0,0,1,20.53,2.71,63.3,63.3,0,0,1,14.42,4.48q5.52,2.66,6.59,6.1l25.83.26a26.51,26.51,0,0,1,4.95.46c1.44.3,2.14.67,2.14,1.12v2.13l-33.2-.32c-1.17,2.6-4.13,5-8.91,7.14a89.17,89.17,0,0,1-18.2,5.62l-12.1-1.68a15.24,15.24,0,0,1-2.67-.63c-.7-.26-1-.53-1-.83s.94-.88,2.81-1.4,4-1.18,6.33-2a66.51,66.51,0,0,0,6.93-2.74,9.41,9.41,0,0,0,4.55-3.78l-78.38-.78a72.88,72.88,0,0,1-6.92,4.47,45.24,45.24,0,0,1-10.17,3.95,105.56,105.56,0,0,1-15.77,2.85,222.2,222.2,0,0,1-23.78,1.16q-10.77.06-21-.81a145.62,145.62,0,0,1-18.24-2.6,57.6,57.6,0,0,1-13.1-4.29c-3.39-1.7-5.3-3.66-5.7-5.87l-21.26-.22a27.91,27.91,0,0,1-5-.44c-1.47-.28-2.22-.66-2.22-1.13v-2.13l29.07.28c1.29-2.24,3.92-4.2,8-5.86a91.52,91.52,0,0,1,14.76-4.44l9.73,1.34c3,.41,4.43.9,4.43,1.46,0,.3-.6.67-1.82,1.12l-4.36,1.6a41.3,41.3,0,0,0-4.85,2.18,10.28,10.28,0,0,0-3.54,2.84Zm-71.73,2.9a7.71,7.71,0,0,0,3.86,3.61,30.65,30.65,0,0,0,7.39,2.49,74.28,74.28,0,0,0,9.95,1.43q5.57.46,11.61.43a117.9,117.9,0,0,0,12.32-.61,70.44,70.44,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,37.94,37.94,0,0,0,5.3-2.83Zm170.63-1.9q-.88-2.11-4.23-3.72a38.44,38.44,0,0,0-8.49-2.68,95,95,0,0,0-12-1.61q-6.84-.54-15.14-.49a116.67,116.67,0,0,0-12.68.65,65.55,65.55,0,0,0-9.22,1.68,33.1,33.1,0,0,0-6.62,2.45,45.32,45.32,0,0,0-5.07,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1931.32,2501.73c-102.29,0-208.79,9-225.82,26.42a22,22,0,0,1,1.86,2c14.36-12.1,102.3-24.28,224-24.28,124.78,0,214.13,12.82,225,25.21a19.71,19.71,0,0,1,1.72-1.94C2143.92,2511.06,2035.42,2501.73,1931.32,2501.73Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1673.27,2474.83v50.88c0,16.44,102.7,29.77,229.4,29.77s229.39-13.33,229.39-29.77v-50.88Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 1454.58,
    cy: 1987.91,
    rx: 229.4,
    ry: 29.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1902.66,2506.65c-112.2,0-229.52-10.72-229.52-31.39,0-1.13.4-3.13,1.54-3.13s.64,1.56.64,2.7c0,13.11,93.37,27.71,227.34,27.71s227.35-14.6,227.35-27.71c0-1.14.19-2.2,1.32-2.2s.87,1.52.87,2.65C2132.2,2496,2014.87,2506.65,1902.66,2506.65Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1881,2476.49c2.25-1.56,4.64-3.1,7.21-4.61a44.71,44.71,0,0,1,9.85-4.11,95,95,0,0,1,15.12-3,192.56,192.56,0,0,1,22.65-1.22q13.31-.08,25,.84a170.9,170.9,0,0,1,20.53,2.72,63.27,63.27,0,0,1,14.42,4.47q5.52,2.67,6.59,6.11l25.83.26a24.92,24.92,0,0,1,5,.46c1.44.29,2.14.66,2.14,1.11v2.13l-33.2-.32q-1.75,3.91-8.91,7.15a90.73,90.73,0,0,1-18.21,5.62l-12.09-1.69a13.64,13.64,0,0,1-2.67-.63c-.7-.25-1-.53-1-.83s.94-.87,2.81-1.4,4-1.17,6.33-2a63.55,63.55,0,0,0,6.93-2.74,9.45,9.45,0,0,0,4.55-3.77l-78.38-.78a80,80,0,0,1-6.92,4.47,45.24,45.24,0,0,1-10.17,3.95,106.83,106.83,0,0,1-15.77,2.84,224.85,224.85,0,0,1-23.78,1.17q-10.77,0-21-.82a142.17,142.17,0,0,1-18.25-2.6,56.39,56.39,0,0,1-13.09-4.29c-3.39-1.7-5.3-3.65-5.7-5.86l-21.26-.22a27,27,0,0,1-5-.45c-1.47-.28-2.22-.66-2.22-1.13v-2.12l29.07.27c1.29-2.24,3.92-4.19,8-5.85a89.26,89.26,0,0,1,14.76-4.44l9.73,1.34c3,.41,4.43.9,4.43,1.45,0,.31-.6.68-1.82,1.13s-2.69,1-4.36,1.6a39.72,39.72,0,0,0-4.85,2.18,10.19,10.19,0,0,0-3.54,2.84Zm-71.73,2.9a7.69,7.69,0,0,0,3.86,3.6,30.25,30.25,0,0,0,7.39,2.5,76.68,76.68,0,0,0,10,1.43c3.71.3,7.57.45,11.61.43s8.23-.2,12.32-.61a72.15,72.15,0,0,0,9.22-1.56,43.27,43.27,0,0,0,6.93-2.29,37.94,37.94,0,0,0,5.3-2.83Zm170.62-1.9c-.58-1.42-2-2.66-4.22-3.72a38.11,38.11,0,0,0-8.49-2.68,94,94,0,0,0-12-1.62q-6.84-.53-15.14-.49a116.67,116.67,0,0,0-12.68.66,67,67,0,0,0-9.22,1.67,33.33,33.33,0,0,0-6.62,2.45,45.32,45.32,0,0,0-5.07,3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1902.7,2448.28c-102.29,0-208.79,9-225.82,26.43a22,22,0,0,1,1.86,2c14.36-12.1,102.3-24.28,224-24.28,124.78,0,214.13,12.81,225,25.21a19.71,19.71,0,0,1,1.72-1.94C2115.3,2457.62,2006.8,2448.28,1902.7,2448.28Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M2027.29,2324.24c0,103-80.56,184.09-183.54,180.93-107.16-3.29-197.29-95.85-197.29-206.6s90.13-191.16,197.29-180C1946.73,2129.29,2027.29,2221.21,2027.29,2324.24Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2055.12,2315.36c0,103-80.57,184.08-183.54,180.92-107.17-3.29-197.3-95.84-197.3-206.6s90.13-191.16,197.3-180C1974.55,2120.41,2055.12,2212.32,2055.12,2315.36Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2047,2314.81c0,98.5-77.09,175.85-175.46,172.67-102.19-3.31-188-91.64-188-197.17s85.8-182.29,188-171.82C1970,2128.57,2047,2216.31,2047,2314.81Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2041.25,2314.42c0,95.25-74.59,170-169.67,166.77-98.64-3.32-181.36-88.63-181.36-190.43s82.72-176,181.36-166C1966.66,2134.41,2041.25,2219.17,2041.25,2314.42Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1870.6,2157.18h0a10.37,10.37,0,0,1,9.16,10.18v17.53a256.07,256.07,0,0,1,30.39,5.28q11.22,2.63,22.29,6.27a10.26,10.26,0,0,1,7,10.53l-2.16,22a8.24,8.24,0,0,1-8.82,7.62,8.32,8.32,0,0,1-2.94-.78,127.38,127.38,0,0,0-15-5.57,136,136,0,0,0-28.21-5.28l-2.58-.21V2275q39.58,11.09,58.3,29.82t18.68,46.54q0,30.16-20.66,48.38c-13.86,12.21-33.29,19.08-58.43,20.57v19.35a8.82,8.82,0,0,1-8.61,9h-.71a9.73,9.73,0,0,1-9.19-9.7v-19.1l-4.08-.18a268.93,268.93,0,0,1-33.85-3.61,217.63,217.63,0,0,1-23.39-5.38,10.08,10.08,0,0,1-7.34-10.42L1793,2372c.55-6.11,6.69-9.67,12.5-7.38a180.68,180.68,0,0,0,53.46,12.25l.17-55.86q-38-9.41-56.77-27.86t-18.8-47.39q0-29.85,20.38-46t57.47-16v-17.93a8.28,8.28,0,0,1,7.85-8.69A7.73,7.73,0,0,1,1870.6,2157.18Zm-9.18,67q-11.75.86-18.31,6.46t-6.57,15.07a20.21,20.21,0,0,0,6.08,15q6.06,6,18.8,9.59Zm16.23,101.16v51.23q12.78,0,19.6-6.09t6.82-17.24q0-10.17-6.34-16.86t-20.08-11Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1840.87,2337.75c5.74-56.62,57.77-80.59,51-132.67-4.19-32.1-28.51-59.15-55.65-80.27-82.32,8.63-146,76.79-146,166,0,101.81,82.72,187.11,181.36,190.43a171.27,171.27,0,0,0,28-1.37C1860.43,2440.84,1836,2386.39,1840.87,2337.75Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M2225.62,1804.71c-33.12-35.36,58.57-168.2,107.64-226.41,42.87-50.86,86.93-103.12,141-96.51,47.51,5.81,93.74,55.91,96.5,103.93C2578.26,1714.89,2272.7,1855,2225.62,1804.71Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M2623.27,3169.78c6.23,5.07,7.38,17.72,8.13,26,.33,3.7.5,5.55.09,6.85-3,9.52-21.48,10.52-50.43,13.48-45.76,4.68-59.37,8.28-62.95,1.47-3.36-6.38,4.76-16.83,5.68-18,4.91-6.19,10.95-8.45,22.61-12.29,21.59-7.1,36.18-11,40.59-12.17C2614.57,3167.77,2619.17,3166.45,2623.27,3169.78Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2596.06,3128l-4.58,52.14c1.3,2.52,16.8,10.07,29.11,3.59l11.76-51.25Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M2260.4,3163.08c7.48,8.25,9.18,23.44,2.68,30.93s-16,1.84-43.22,2.65c-29.18.87-36.8,7.76-56.62,2.29-8-2.21-22.16-7.58-21.89-13.3.19-4,7.39-6.1,31.44-14.16,34.15-11.43,34-12.06,41.25-13.26C2232.25,3155.21,2250.54,3152.18,2260.4,3163.08Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M2241.71,3115.49l-14.63,48.68c1.1,2.61,16,11.32,28.75,5.8l21.73-47.24Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M2371.73,2049.45a4559.49,4559.49,0,0,1-40.05,547.34,4559.43,4559.43,0,0,1-104,532.87l56,15.07C2331,3100.57,2390.77,3031,2419.6,2932.8c17.9-61,11.93-92.32,23.28-167.32,18.08-119.42,54.68-182,92.52-278.29,34-86.54,74.19-213.54,95.74-383.3Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2540.25,2033.84q17.14,312.08,27.95,635.65,8,242.76,11.87,479.32l57.22,7.06a666.43,666.43,0,0,0,59.67-154c20.36-81.65,15.64-130.14,24.58-214.76,10-94.92,24.57-115.6,50.35-235.33,52.33-243,78.5-364.5,20.12-440.07C2773.07,2087.18,2713.66,2025.63,2540.25,2033.84Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2818.19,1511a888,888,0,0,0-190.28-31.78c-114.33-6.46-171.5-9.7-212,17.53-93.57,62.88-21.13,208-59.43,567.8-5.47,51.38-6.7,103.12-10.66,154.64-6.55,85.3-8.05,89.93-2.11,98.57,37.22,54.2,176.07-27.55,379.59,4.76,113.88,18.09,165.52,59.74,196.72,29.7,36.38-35,5.17-129.29-21.69-210.42-30.84-93.13-49.89-94.32-67.39-164.46-18.3-73.31-7.23-111-4.38-226.65A2049,2049,0,0,0,2818.19,1511Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2541.43,2186.39c53.19-4.16,87.7,25.91,133.62,2.47,63-32.13,83.2-132.13,79.18-202.9-6.09-107.53-67.49-135.87-56.91-205.38,5.72-37.59,32.56-87.49,128.92-138.48,1.28,42.91,1,79.49.32,108.55-2.85,115.6-13.92,153.34,4.38,226.65,17.5,70.14,36.55,71.33,67.39,164.46,26.86,81.13,58.07,175.38,21.69,210.42-31.2,30-82.84-11.61-196.72-29.7-175.36-27.84-302.65,28.93-358.34,10.52C2432.26,2221.79,2493.3,2190.16,2541.43,2186.39Z",
    transform: "translate(-448.09 -486.92)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2745.63,1518.34c38-31.22,114.38,4.12,134.8,13.56,113.87,52.67,216.11,194.61,190.78,344.61-3.8,22.5-21.42,127.72-110.52,178.71-80.39,46-189,34.17-275.93-31l-35.66-31.64-35.1-37.91a281.52,281.52,0,0,1,93.48-51.5c57.84-18.67,99.94,14.82,126.77-10.64,18.52-17.57,18.56-48.6,14-67.41-9.22-37.9-42.63-48.56-70.52-75.47C2712.21,1686.44,2700.14,1555.71,2745.63,1518.34Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "1751.58 1521.1 2260.8 1513.5 2125.39 1578.85 1750.28 1554.3 1751.58 1521.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2726.86,2014h0a22.68,22.68,0,0,1-14.92,21.3L2549.23,2099l-.74-44.22,160.4-54.4a14.08,14.08,0,0,1,18,13.62Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2648.45,1983.82c3.12-.7-15.23-37.26-29.63-33s-84.87,45-91.27,61.87l-6.4,16.81s30.73,2.4,49.79-4S2623,1989.49,2648.45,1983.82Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2535,1744.53l35.89,326.81c1.24,11.28-14.55,28.08-25.88,27.55l-526.56-32.33a18.46,18.46,0,0,1-17.32-15.32L1935,1735.6c-2-11.49,18.68-23.35,30.33-23l551.8,15.52A18.47,18.47,0,0,1,2535,1744.53Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2522.94,1754.06l35.9,326.82a18.46,18.46,0,0,1-16.34,20.36,17.46,17.46,0,0,1-2.89.09l-533.21-25.24a18.47,18.47,0,0,1-17.33-15.32l-54.47-317.08a18.45,18.45,0,0,1,15-21.32,18,18,0,0,1,3.67-.26l551.8,15.51A18.45,18.45,0,0,1,2522.94,1754.06Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2209.84,1999.51c46.56-19.73,30.12-57.37,85.1-104.26,72.53-61.86,146.46-35,172.34-83,8.06-14.93,11.91-38.16-2.13-75.77l40,1.12A18.45,18.45,0,0,1,2523,1754l35.9,326.82a18.48,18.48,0,0,1-19.23,20.45l-533.21-25.24a18.48,18.48,0,0,1-17.33-15.32L1981.6,2017a201.67,201.67,0,0,1,58.07-21.77C2117.85,1979.39,2156.23,2022.23,2209.84,1999.51Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1972.8,2030.38a4.17,4.17,0,0,1,3.74-5.49c11.27-.57,37.41-.81,51.84,8,18.74,11.48,43,32.43,22.57,43l-19.06,9.88a4.09,4.09,0,0,1-2.79.38c-6.77-1.49-35.27-7.81-38.39-9.38C1987.87,2075.37,1977,2043.12,1972.8,2030.38Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M2619.41,1359a374.13,374.13,0,0,0,6.68,74.82c3.87,19.93,6.66,25.08,10.22,29.26,5.36,6.29,13.48,11.56,59.38,22.94,25,6.19,28.18,6,28.73,8.5,2.69,12.09-65.4,53.3-135.76,43.37-43.06-6.08-82.23-30.65-79.83-43.55s45.43-6,58.25-29.5c8.92-16.34-1.08-39.53-12.89-58.74C2565.63,1384.67,2608,1380.47,2619.41,1359Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M2549.08,1354.26c-5.17-16.09,2-38.57,17.93-48.8,13.73-8.81,29.31-5.33,38.64-3.25,27,6,56.07,28.27,59.17,56.16,1.83,16.52-23,40.9-27.15,45.4-4.68,5.09-10.09,5.51-16,8.53-8.21,4.19-21.11,10.89-42.32,22.24a112.59,112.59,0,0,0,.22-19.69c-.23-2.93-1.24-14.42-5.14-25C2566.61,1368.61,2554,1369.51,2549.08,1354.26Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2606.19,1428.13s-26.82,22.1-60.08,8.07c-29.77-12.56-10.51-82.43,14-90.17,8.18-2.58,21.87-.07,31.42,6.56,5.63,3.92,6.84,7.25,16.18,13.47,8.61,5.74,11.64,5.62,13.66,9,2.53,4.24,2.59,12.52-10.31,30.42,7.85-3.86,15.61-3.7,19.75.35a11.13,11.13,0,0,1,2.68,5.36C2635,1420.5,2624.43,1428,2606.19,1428.13Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2624.15,1371.47c-1.85.58.74,7.63-1.62,15.5-4.58,15.28-26.1,28.07-42.18,24.2-9.51-2.29-10.11-8.71-24.75-15.59a73.37,73.37,0,0,0-22.61-6.42c-10.51,14.86-11.74,32.88-3.35,44.35,9,12.36,25.94,12.64,33,12.76,4.73.08,19.88.36,31.32-9.65,11.93-10.43,7.38-20.79,18.94-26.63,5.82-3,12.12-2.91,20.59-9.6a43.73,43.73,0,0,0,5.1-4.71C2633.63,1384.62,2626.83,1370.62,2624.15,1371.47Z",
    transform: "translate(-448.09 -486.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M2541.92,1399.12s5.38,5.72,17,9c.56.16,1.11.54,1.08.85-.11,1.17-9.08,3.47-15.15-.75-4.3-3-6.45-8.81-5.41-9.74C2539.87,1398.12,2540.92,1398.56,2541.92,1399.12Z",
    transform: "translate(-448.09 -486.92)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetBanner);
export default __webpack_public_path__ + "static/media/asset-banner.49d8352717a7522dc1515c40ae37123b.svg";
export { ForwardRef as ReactComponent };